var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { Modal } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { styled } from '@mui/system';
export var useSimpleModal = function (message, _a) {
    var _b = _a === void 0 ? {} : _a, showOnce = _b.showOnce, buttons = _b.buttons, modalProps = _b.modalProps, _c = _b.initialOpen, initialOpen = _c === void 0 ? false : _c, buttonProps = _b.buttonProps, toggleWhen = _b.toggleWhen, onClose = _b.onClose;
    var _d = useState(false), hasShown = _d[0], setHasShown = _d[1];
    var _e = useState(initialOpen), open = _e[0], setOpen = _e[1];
    var toggle = function (value) {
        if (hasShown && showOnce)
            return;
        if (value !== undefined)
            setOpen(value);
        else {
            if (open)
                closeModal();
            else
                setOpen(true);
        }
    };
    var _f = useState(true), visible = _f[0], setVisible = _f[1];
    var closeModal = function () {
        hasShown && showOnce && setHasShown(true);
        onClose && onClose();
        setVisible(false);
        setTimeout(function () {
            setOpen(false);
        }, 100);
        setTimeout(function () {
            setVisible(true);
        }, 500);
    };
    useEffect(function () {
        var listener = function (e) {
            if (!open)
                return;
            e.preventDefault();
            e.stopPropagation();
            if (e.key === 'Enter') {
                closeModal();
            }
        };
        window.document.addEventListener('keydown', listener);
        return function () {
            window.document.removeEventListener('keydown', listener);
        };
    }, [open]);
    useEffect(function () {
        if (toggleWhen) {
            return toggle(true);
        }
    }, [toggleWhen]);
    var buttonsMemo = useMemo(function () { return buttons; }, []);
    var modal = (_jsx(Modal, __assign({ open: open, onClose: closeModal }, { children: _jsx(_Fragment, { children: _jsx(AnimatePresence, { children: visible && (_jsxs(MotionModalWrapper, __assign({}, modalProps, { initial: { scale: 0, x: '-50%', y: '0%' }, animate: { scale: 1, x: '-50%', y: '-50%' }, exit: { scale: 0, x: '-50%', y: '0%' } }, { children: [_jsx(Content, { children: typeof message === 'string' ? (_jsx(Typography, { children: message })) : (message) }), buttonsMemo || (_jsx("div", __assign({ className: "grid place-items-center" }, { children: _jsx(Button, __assign({}, buttonProps, { className: buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, variant: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.variant) || 'contained', onClick: closeModal }, { children: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.text) || 'OK' })) })))] }), "modal")) }) }) })));
    return [modal, toggle, open];
};
var ModalWrapper = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90vw',
            maxWidth: '500px',
            backgroundColor: 'white',
            borderRadius: '1rem',
            padding: '.5rem',
            maxHeight: 'calc(100vh - 4rem)',
            gap: '2rem',
            overflow: 'hidden',
            display: 'grid',
            gridTemplateRows: '1fr auto'
        },
        _b[theme.breakpoints.up('md')] = {
            padding: '2rem',
        },
        _b);
});
var MotionModalWrapper = motion(ModalWrapper);
var Content = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        maxHeight: '100%',
        overflowY: 'auto',
        padding: '1rem',
    });
});
